import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './goodmanager.json'; // The JSON you provided

const Goodmanager = () => {
  return (
    <div className="topic-page-container">
        {/* We can still use your Layout, but we pass the Router as children or a prop */}
        <TopicsPageLayout
            
            description="Management vocabulary, leadership styles, and workplace English. B2 level exercises with grammar, reading, and discussion."
            level="B2"
            title="Good Manager"
            image="/Images/officerules2.webp"
            seoTitle="Free English Lesson Plans: Being a Good Manager"
            seoDescription="Management vocabulary, leadership styles, and workplace English. B2 level exercises with grammar, reading, and discussion."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default Goodmanager;


